import { IconStorage } from "@app/shared/icons/interfaces";

export const countyMap: IconStorage = {
  svgCode: () => (
    <>
      <path d="M43 0H3C1.34315 0 0 1.34315 0 3V27C0 28.6569 1.34315 30 3 30H43C44.6569 30 46 28.6569 46 27V3C46 1.34315 44.6569 0 43 0Z" fill="#EEF1F5" />
      <path d="M6 4H40L42 26H4L6 4Z" fill="white" stroke="#7346DA" strokeWidth="1.2" />
      <path d="M14 17C15.1046 17 16 16.1046 16 15C16 13.8954 15.1046 13 14 13C12.8954 13 12 13.8954 12 15C12 16.1046 12.8954 17 14 17Z" fill="#008559" />
      <path d="M20 21C21.1046 21 22 20.1046 22 19C22 17.8954 21.1046 17 20 17C18.8954 17 18 17.8954 18 19C18 20.1046 18.8954 21 20 21Z" fill="#008559" />
      <path d="M26 14C27.1046 14 28 13.1046 28 12C28 10.8954 27.1046 10 26 10C24.8954 10 24 10.8954 24 12C24 13.1046 24.8954 14 26 14Z" fill="#056EDF" />
      <path d="M33 9C34.8 9 36 10.4 36 11.8C36 13.8 33 16 33 16C33 16 30 13.8 30 11.8C30 10.4 31.2 9 33 9Z" fill="#7346DA" />
    </>
  ),
  svgProps: { fill: "none", height: "30", viewBox: "0 0 46 30", width: "46" },
};
